// test1386
(1386 && 0);
